import React, { useState } from 'react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';

interface FeedbackCreateFormProps {
  onSubmit: (description: string) => Promise<void>;
  onCancel?: () => void;
  submitLabel?: string;
}

const FeedbackCreateForm: React.FC<FeedbackCreateFormProps> = ({
  onSubmit,
  onCancel,
  submitLabel = 'Создать заявку',
}) => {
  const [description, setDescription] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      await onSubmit(description);
      setDescription('');
    } catch (err: any) {
      setError(err.message || 'Ошибка при создании заявки');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form.Group className="mb-3">
        <Form.Label>Описание (необязательно)</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          placeholder="Опишите вашу заявку..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          disabled={loading}
        />
      </Form.Group>
      <div className="d-flex gap-2">
        <Button type="submit" variant="primary" disabled={loading}>
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Создание...
            </>
          ) : (
            submitLabel
          )}
        </Button>
        {onCancel && (
          <Button variant="outline-secondary" onClick={onCancel} disabled={loading}>
            Отмена
          </Button>
        )}
      </div>
    </Form>
  );
};

export default FeedbackCreateForm;
